'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ControlLabel = require('react-bootstrap/lib/ControlLabel');

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ControlLabel2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/ControlLabel.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/ControlLabel.js
 ** module chunks = 0
 **/